import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import persistedFilterState from './mixins/persistedFilterState'

Vue.config.productionTip = false
Vue.mixin(persistedFilterState)


import Autocomplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'

import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import './styles/detail-actions.css';
import './styles/table-layout.css';
import './styles/theme.css';
import SortableTableHeader from './components/SortableTableHeader.vue';
import TableLoadingBar from './components/TableLoadingBar.vue';
import CompactPagination from './components/CompactPagination.vue';
import AppIcon from './components/AppIcon.vue';
import CollapsibleNotesField from './components/CollapsibleNotesField.vue';
import PlusIcon from 'lucide-vue/dist/esm/icons/plus.js';

Vue.component('sortable-table-header', SortableTableHeader);
Vue.component('table-loading-bar', TableLoadingBar);
Vue.component('compact-pagination', CompactPagination);
Vue.component('AppIcon', AppIcon);
Vue.component('collapsible-notes-field', CollapsibleNotesField);
Vue.component('PlusIcon', PlusIcon);


Vue.use(VueToast, {
  position: 'bottom'
});

window.vueOpener = Vue.$toast 
import VueSweetalert2 from 'vue-sweetalert2';

import 'sweetalert2/dist/sweetalert2.min.css';

import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

Bugsnag.start({
  apiKey: process.env.VUE_APP_BUGSNAG_API_KEY,
  plugins: [new BugsnagPluginVue()],
  autoTrackSessions: false
})

window.Bugsnag = Bugsnag

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

let lang = 'fr'
if(!localStorage.getItem('currentLang')){
  const browserLang = navigator.language ? navigator.language.split('-')[0] : 'en';
  lang = ['fr', 'en', 'ar'].includes(browserLang) ? browserLang : 'en';
  localStorage.setItem('currentLang',lang)
}


const i18n = new VueI18n({
  locale: lang, // set locale,
  fallbackLocale : 'en',
  messages : loadLocaleMessages(), // set locale messages
})

window._i18n = i18n

Vue.use(VueSweetalert2);
Vue.use(Autocomplete)

new Vue({
  
  router,
  store,
  render: h => h(App),
  i18n
}).$mount('#app')
